import { makeAutoObservable, runInAction } from 'mobx';

import {
  addApp,
  deleteApp,
  editApp,
  getApp,
  getAppDetail,
  getEnvList,
  getUserList,
} from '@/api';

class Layout {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  collapsed = false;

  setCollapsed(value) {
    this.collapsed = value;
  }

}

export default new Layout();
